<!-- 缺省图组件 -->
<template>
  <div
    :class="onClass"
    class="rt-defaultImage"
  >
    <div
      v-if="!text"
      :class="classes"
      class="image-content"
    >
      <slot v-if="!textOnly">
        <rt-icon
          :size="iconSize"
          :name="iconName"
        />
      </slot>
    </div>
    <div
      :class="{ 'is-text': text }"
      class="describe"
    >
      <slot name="describe">
        {{ $tx('暂无数据', 'xpc.defaultImage.noData') }}
      </slot>
    </div>
  </div>
</template>

<script>
import rtIcon from '../icon/rtIcon';
export default {
  name: 'RtDefaultImage',
  components: {
    rtIcon
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    iconName: {
      type: String,
      default: 'rt-base-default_image'
    },
    text: {
      type: Boolean,
      default: false
    },
    textOnly: Boolean
  },
  computed: {
    classes () {
      return `${this.size}`;
    },
    onClass () {
      return `is-${this.size}`;
    },
    iconSize () {
      let size = this.size;
      let iconSize = '';
      switch (size) {
        case 'small':
          iconSize = 160;
          break;
        case 'medium':
          iconSize = 240;
          break;
        case 'large':
          iconSize = 320;
          break;
        default:
          iconSize = 320;
      }
      return iconSize;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDefaultImage.vue?26f6d596